<template>
  <div class="homePage">
    <!-- 头部登录 -->
    <Header-Top ref="getcount"></Header-Top>
    <!-- 店铺首页搜索 -->
    <Store-Header
      :shopName="this.shopName"
      :logoTop="this.storeList.logoTop"
      :shopId="this.shopId"
      :tenantId="this.tenantId"
      :activeName="'homePage'"
    ></Store-Header>
    <Slider></Slider>
    <div class="main">
      <!-- 店铺信息  -->
      <div class="main-Store">
        <div class="Store-span">
          <span class="iconfont icon-shangcheng"></span>
          <span class="span">店铺信息</span>
        </div>
        <div class="Store-list">
          <img
            v-if="storeList.facadeImage"
            :src="storeList.facadeImage"
            alt="11111"
          />
          <img v-else src="@/assets/images/home/store-img.jpg" alt="11111" />
          <div class="all-list">
            <div class="Store-left">
              <span v-show="storeList.storeType == 5" class="span-shopType">{{
                storeList.shopType
              }}</span>
              <span v-show="storeList.storeType == 9" class="span-shopType w2">{{
                storeList.shopType
              }}</span>
              <span v-show="storeList.storeType == 3" class="span-shopType w3">{{
                storeList.shopType
              }}</span>
              <span v-show="storeList.storeType == 7" class="span-shopType w4">{{
                storeList.shopType
              }}</span>
              <span class="iconfont icon-a-zu248"></span>
              <span class="li-1-span">{{ shopName }}</span>
              <xiaopei :oppositeTenantId="tenantId">
                <i class="iconfont icon-a-lujing162"></i
              ></xiaopei>
              <span class="li-2-span"
                >{{ storeList.provinceName }}&nbsp;{{
                  storeList.cityName
                }}</span
              >
            </div>
            <div class="Store-right">
              <div class="carType-left">
                <p>
                  主营车型：
                  <Tooltip
                    :content="storeList.tenantCarBrandListVoList"
                    theme="light"
                    max-width="450"
                  >
                    <span class="span-Tooltip1">{{
                      storeList.tenantCarBrandListVoList
                    }}</span>
                  </Tooltip>
                </p>
                <p class="w10">
                  主营品牌：
                  <Tooltip
                    :content="storeList.tenantPartBrandListVoList"
                    theme="light"
                    max-width="450"
                  >
                    <span class="span-Tooltip1">{{
                      storeList.tenantPartBrandListVoList
                    }}</span>
                  </Tooltip>
                </p>
              </div>
              <div class="carType-right">
                <p>
                  <span> 服务区域：{{ storeList.businessArea }}</span>
                </p>
                <p class="w10">
                  <span> 月销量：{{ monthlySales }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 热销配件 -->
      <div class="main-HotParts">
        <div class="main-common">
          <!-- <span class="iconfont icon-a-lujing147"></span> -->
          <span>热销配件</span>
        </div>
        <div class="HotParts mian-common-div">
          <ul>
            <li v-for="item in hortPartsList" :key="item.id">
              <router-link
                rel="opener"
                :to="{
                  path: '/Partsdetails',
                  query: { partId: item.id }
                }"
              >
                <div class="w11">
                  <!-- <div class="span-3" v-show="item.qualityTypeName">
                    <i>{{
                      item.qualityTypeName ? item.qualityTypeName.name : ''
                    }}</i>
                  </div> -->
                  <div class="w112">
                    <img v-if="item.pictureUrl" :src="item.pictureUrl" />
                    <img
                      v-else
                      src="@/assets/images/shoppingCart/2.png"
                      alt="图片缺失"
                    />
                  </div>
                </div>

                <div class="HotParts-div">
                  <!-- <div class="w12">
                    <span class="span-1 c" v-if="item.inquiry == 1">询价</span>
                    <span class="span-1 c" v-else
                      >￥{{ item.price || 0.0 }}</span
                    >
                    <span class="span-2 c"
                      >库存：{{ item.stock > 10 ? '10+' : item.stock
                      }}{{ item.stock > 10 ? '' : '个' }}</span
                    >
                  </div> -->
                  <div class="ceshi2">
                    <span class="span-3" v-show="item.qualityTypeName">
                      <i>{{
                        item.qualityTypeName ? item.qualityTypeName.name : ''
                      }}</i>
                    </span>
                    <Tooltip
                      :content="item.oeCode"
                      theme="light"
                      max-width="200"
                    >
                      <span class="c oeCode">{{ item.oeCode }}</span>
                    </Tooltip>
                  </div>
                  <div class="ecshi">
                    <Tooltip
                      :content="item.carBrandName"
                      theme="light"
                      max-width="200"
                    >
                      <span class="c car-span">{{ item.carBrandName }}</span>
                    </Tooltip>
                    <!-- &nbsp;&nbsp;
                    <Tooltip
                      :content="item.stdNameJp"
                      theme="light"
                      max-width="200"
                    >
                      <span class="c part-span">{{ item.stdNameJp }}</span>
                    </Tooltip> -->
                  </div>
                  <div class="ecshi">
                    <!-- <Tooltip
                      :content="item.carBrandName"
                      theme="light"
                      max-width="200"
                    >
                      <span class="c car-span">{{ item.carBrandName }}</span>
                    </Tooltip>
                    &nbsp;&nbsp; -->
                    <Tooltip
                      :content="item.stdNameJp"
                      theme="light"
                      max-width="200"
                    >
                      <span class="c part-span">{{ item.stdNameJp }}</span>
                    </Tooltip>
                  </div>
                  <div class="ecshi">
                    <span
                      class="span-4"
                      v-show="item.inquiry == 0"
                      @click="BuyShop(item)"
                      >立即购买>></span
                    >
                    <span
                      v-show="item.inquiry == 1"
                      class="span-4 span-5"
                      @click="enquiry(item)"
                      >立即询价>></span
                    >
                  </div>
                </div>
              </router-link>
              <!-- <div class="spans"> -->
              <!-- <div> -->
              <!-- <span
                    v-if="item.attention == true"
                    class="iconfont icon-a-ziyuan1"
                    title="收藏"
                    @click="getCollect(item)"
                  ></span>

                  <span
                    v-else
                    class="iconfont icon-a-lujing157"
                    title="收藏"
                    @click="getCollect(item)"
                  ></span>
                  <span
                    v-show="item.inquiry == 0"
                    class="iconfont icon-gouwuche span-icon"
                    @click="addShop(item)"
                  ></span>

                  <span
                    v-show="item.inquiry == 1"
                    class="iconfont icon-gouwuche noregular"
                  ></span> -->

              <!-- <span
                  class="iconfont icon-a-lujing162"
                  @click="go('im')"
                ></span> -->
              <!-- <xiaopei :oppositeTenantId="tenantId" :partId="item.id">
                    <i class="iconfont icon-a-lujing162"></i>
                  </xiaopei>
                </div> -->
              <!-- <span
                  class="span-4"
                  v-show="item.inquiry == 0"
                  @click="BuyShop(item)"
                  >立即购买</span
                >
                <span
                  v-show="item.inquiry == 1"
                  class="span-4 span-5"
                  @click="enquiry(item)"
                  >立即询价</span
                >
              </div> -->
            </li>
          </ul>
          <div v-if="!hortPartsList.length" class="w105">
            <!-- <img
              src="@/assets/images/shoppingCart/2.png"
              style="width: 300px; height: 350px"
              alt=""
            /> -->
            <p>
              <Icon type="ios-alert-outline" size="17" />&nbsp;&nbsp;暂无数据
            </p>
          </div>
        </div>
      </div>
      <!-- 活动配件 -->
      <!-- <div class="main-EventParts">
        <div class="main-common">
          <span class="iconfont icon-a-lujing176"></span>
          <span>活动配件</span>
        </div>
        <div class="EventParts mian-common-div">
          <ul>
            <li v-for="item in this.EventPartsList" :key="item.id">
              <img
                :src="
                  item.url ||
                  'https://img.g-part.cn/test/oms/2021/12/22/16401582230616431.jpg'
                "
                alt=""
              />
              <div class="HotParts-div">
                <div>
                  <span class="span-1">￥{{ item.price || '暂无' }}</span
                  ><span class="span-2"
                    >库存：{{ item.stock > 10 ? '10+' : item.stock
                    }}{{ item.stock > 10 ? '' : '个' }}</span
                  >
                </div>
                <div>
                  <span>{{ item.oeCode || '暂无' }}</span
                  >&nbsp;&nbsp;<span class="span-3"
                    >{{ item.qualityTypeName.name || ' 暂无' }}
                  </span>
                </div>
                <div>
                  <span>{{ item.carBrandName }}</span> &nbsp;&nbsp;<span>{{
                    item.partTypeName
                  }}</span>
                </div>
                <div>
                  <span class="iconfont icon-a-lujing157"></span>
                  <span class="iconfont icon-a-zu420 span-icon"></span>
                  <span class="iconfont icon-a-lujing162"></span>
                  <span class="span-4">立即购买</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div> -->
      <!-- 产品上新 -->
      <!-- <div class="main-NewProduct">
        <div class="main-common">
          <span class="iconfont icon-a-lujing143"></span>
          <span>产品上新</span>
        </div>
        <div class="NewProduct mian-common-div">
          <ul>
            <li v-for="item in NewProductList" :key="item.id">
              <img
                :src="
                  item.url ||
                  'https://img.g-part.cn/test/oms/2021/12/22/16401582230616431.jpg'
                "
                alt=""
              />
              <div class="HotParts-div">
                <div>
                  <span class="span-1">￥{{ item.price || '暂无' }}</span
                  ><span class="span-2"
                    >库存：{{ item.stock > 10 ? '10+' : item.stock
                    }}{{ item.stock > 10 ? '' : '个' }}</span
                  >
                </div>
                <div>
                  <span>{{ item.oeCode || '暂无' }}</span
                  >&nbsp;&nbsp;<span class="span-3"
                    >{{ item.qualityTypeName.name || '暂无' }}
                  </span>
                </div>
                <div>
                  <span>{{ item.carBrandName }}</span> &nbsp;&nbsp;<span>{{
                    item.partTypeName
                  }}</span>
                </div>
                <div>
                  <span class="iconfont icon-a-lujing157"></span>
                  <span class="iconfont icon-a-zu420 span-icon"></span>
                  <span class="iconfont icon-a-lujing162"></span>
                  <span class="span-4">立即购买</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div> -->
      <!-- 厂商介绍 -->
      <div class="Firmennachweis">
        <div class="Firmennachweis-top">
          <div class="Firmennachweis-icon">
            <!-- <span class="iconfont icon-gongsi"></span> -->
            <span class="span"> 店铺介绍</span>
          </div>
          <div class="div-p" v-show="storeList.description">
            <div v-html="storeList.description" class="w111"></div>
          </div>
          <div v-show="!storeList.description" class="v-shows">
            <span
              ><Icon type="ios-alert-outline" size="17" />&nbsp; 暂无介绍</span
            >
          </div>
          <!-- <div v-for="item in aa" :key="item.carBrandId">
            {{ item.carBrandName }}
          </div> -->
        </div>
      </div>
      <div style="height: 11px"></div>
    </div>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
    <Footer></Footer>
    <footerP></footerP>
  </div>
</template>

<script>
import xiaopei from '@/views/xiaopei/index.vue'
// import { awaken } from '@/api/xiaopei/shout.js'
import {
  getBasicShopMsg,
  getSalesVolume,
  getshopcar,
  prebuy,
  getsales,
  getattention
} from '../../api/store'
import Footer from '../base/common/footer.vue'
import footerP from '@/views/base/common/footer-p.vue'
import Slider from '../base/common/slider.vue'
import HeaderTop from '../base/common/header-top.vue'
import StoreHeader from '../base/common/store-Header.vue'
import enquirytk from '@/views/base/common/enquirytk.vue'
export default {
  // mixins: [awaken],
  name: 'homePage',
  components: {
    HeaderTop,
    StoreHeader,
    xiaopei,
    enquirytk,
    Slider,
    Footer,
    footerP
  },
  data() {
    return {
      enquirydata: {}, // 询价的数据
      a: '',
      b: '',
      monthlySales: '', // 月销量
      storeList: {},
      tenantId: this.$route.query.tenantId,
      shopId: this.$route.query.shopId,
      shopName: this.$route.query.shopName,
      // shopName: '上海艾森沃克汽车零部件有限公司',
      hortPartsList: [], // 热销配件
      // 活动配件
      // EventPartsList: [ ],
      //产品上新
      // NewProductList: [ ],
      //厂商介绍
      description: ''
    }
  },
  created() {
    this.getBasicShopMsg()
    this.getsales()
    this.getSalesVolume()
  },
  methods: {
    // 立即询价
    enquiry(item) {
      this.enquirydata = JSON.parse(JSON.stringify(item))
      this.$refs.enquirytkl.enquirytkc()
    },
    // 询价刷新
    enquirysx() {
      this.$refs.getcount.getenquirydata()
    },
    async getCollect(item) {
      console.log(item, 'item')
      item.attention = !item.attention
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      const res = await getattention({
        partId: item.id,
        attention: item.attention
      })
      console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
    },
    // 获取店铺信息
    async getBasicShopMsg() {
      const res = await getBasicShopMsg({
        tenantId: this.tenantId,
        shopId: this.shopId
      })
      console.log('店铺首页信息---', res)
      if (res.status) {
        this.storeList = res.data
        console.log(this.storeList)
        this.a = res.data.tenantCarBrandListVoList.map((item) => {
          return item.carBrandName
        })
        this.storeList.tenantCarBrandListVoList = this.a.toString()
        this.b = res.data.tenantPartBrandListVoList.map((item) => {
          return item.carBrandName
        })
        this.storeList.tenantPartBrandListVoList = this.b.toString()
      }
    },
    // 获取月销量
    async getsales() {
      const res = await getsales({
        tenantId: this.tenantId
      })
      console.log(res)
      if (res.status) {
        this.monthlySales = res.data
      }
    },
    // 热销配件
    async getSalesVolume() {
      const res = await getSalesVolume({
        num: 5,
        shopId: this.shopId,
        tenantId: this.tenantId
      })
      console.log('热销配件（商铺）---', res)
      if (res.status) {
        this.hortPartsList = res.data.list
      }
    },
    // 购物车
    async addShop(val) {
      if (this.hortPartsList.length > 0) {
        const data = {
          shopId: this.shopId,
          shopName: this.shopName,
          partId: val.id,
          partNum: 1,
          partQualityType: val.qualityTypeName.value,
          partInnerId: '',
          partCode: val.oeCode,
          carBrandName: val.carBrandName,
          stdNameJp: val.stdNameJp,
          direction: val.direction,
          price: val.price,
          tenantId: val.tenantId
        }
        const res = await getshopcar(data)
        if (res.status == true) {
          this.$refs.getcount.getCount()
          this.$Message.success('加入购物车成功！')
        } else {
          // this.$Message.error(res.message)
        }
      }
    },
    // 立即购买
    async BuyShop(val) {
      // console.log(val);
      // const res = await prebuy({
      //   partId: val.id,
      //   tenantId: val.tenantId,
      //   partNum: 1,
      //   shopId: this.shopId
      // })
      // if (res.status) {
      // this.$router.push({
      //   path: '/orderInformation',
      //   query: { pid: res.data.previewOrderId }
      // })
      // window.open(routeInfo.href)
      // }
    }
    // 活动配件
  },
  computed: {},
  watch: {}
}
</script>
<style lang="less" scoped>
.homePage {
  .main {
    width: 1200px;
    margin: 0 auto;
    // height: 100%;
    // 公共样式
    .main-common {
      border-bottom: 1px solid #e2e2e2;
      margin-bottom: 6px;
      text-align: left;
      height: 40px;
      line-height: 40px;
      background: #f6f6f6;
      .iconfont {
        color: #f62b4e;
        padding-right: 7px;
      }
      span {
        padding-left: 11px;
        font-size: 14px;
        color: #505050;
        font-weight: bold;
      }
    }
    .mian-common-div {
      ul {
        display: flex;
        // justify-content: space-around;
        li {
          background: #ffffff;
          // cursor: pointer;
          width: 220px;
          // width: 20%;
          border: 1px solid #e2e2e2;
          // width: 19%;
          // padding: 8px 21px 8px 19px;
          margin: 1% 1%;
          // margin-right: 25px;
          a {
            width: 100%;
            display: inline-block;
            .w11 {
              padding-bottom: 7px;
              // border-bottom: 1px solid #e2e2e2;

              .w112 {
                margin: 18px auto;
                width: 170px;
                height: 137px;
                // margin-left: 35px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;

                  // width: auto;
                  // height: auto;
                  // //如果图片比例不为一比一 则可以适当增加比例以满足充满盒子
                  // max-width: 100%;
                  // max-height: 100%;
                  // height: 127px;
                  // margin-left: 35px;
                  // margin-bottom: 7px;
                }
              }
            }

            .HotParts-div {
              // height: 81px;
              text-align: left;
              font-size: 12px;
              color: #8a8a8a;
              padding: 14px 10px 5px 15px;
              .span-1 {
                font-weight: bold;
                font-size: 16px;
                color: #f62b4e;
                padding-right: 18px;
                cursor: pointer;
              }
              .span-2 {
                font-size: 12px;
                // font-weight: 500;
                cursor: pointer;
                color: #444650;
              }

              .c {
                cursor: pointer;
              }
              .w12 {
                display: flex;
                justify-content: space-between;
                line-height: 24px;
              }
              .ceshi2 {
                // margin-top: 8px;
                display: flex;
                // justify-content: space-around;
                .oeCode {
                  color: #444650;
                  font-weight: bold;
                  font-size: 14px;
                  display: inline-block;
                  width: 130px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .span-3 {
                  // padding-top: 11px;
                  // height: 34px;
                  font-size: 12px;
                  font-weight: 500;
                  color: #ffffff;
                  padding-right: 10px;
                  i {
                    // padding-top: 11px;
                    // margin: 11px 0 0 10px;
                    padding: 2px 4px;
                    background: #47c460;
                  }

                  // padding: 2px 4px;
                  // background: #47c460;
                  // color: #ffffff;
                  // border-radius: 2px;
                  // cursor: pointer;
                }
              }
              .ecshi {
                display: flex;
                span {
                  font-size: 12px;
                  color: #444650;
                }
                .car-span {
                  display: inline-block;
                  padding-top: 10px;
                  // width: 100px;
                  // overflow: hidden;
                  // text-overflow: ellipsis;
                  // white-space: nowrap;
                }
                // }
                // .ivu-tooltip-rel {
                .part-span {
                  padding-top: 10px;
                  // max-width: 100px;
                  display: inline-block;
                  // width: 0px;
                  // overflow: hidden;
                  // text-overflow: ellipsis;
                  // white-space: nowrap;
                  // }
                  // }
                }
                .span-4 {
                  font-size: 14px;
                  font-weight: 400;
                  padding-top: 7px;
                  // height: 14px;
                  margin-left: 52px;
                  color: #ff5e00;
                  padding: 4px 11px;
                  border-radius: 2px;
                  // background-color: #ff5e00;
                  cursor: pointer;
                }
                .span-5 {
                  color: #377cf1;
                }
                // }
              }
            }
          }
          .spans {
            display: flex;
            justify-content: space-between;
            padding: 0 10px 9px 10px;
            cursor: pointer;
            font-size: 20px;
            .span-4 {
              // font-size: 14px;
              // height: 14px;
              margin-left: 16px;
              color: #ffffff;
              padding: 4px 11px;
              border-radius: 2px;
              background-color: #ff5e00;
              cursor: pointer;
            }
            .span-5 {
              background-color: #377cf1;
            }
            .iconfont {
              font-size: 14px;
              cursor: pointer;
              // font-size: 20px;
              .icon-a-lujing157,
              .icon-a-ziyuan1 {
                color: #ff8800;
              }
            }
            .span-icon {
              padding: 0 8px 0;
              color: #ff0011;
            }
            .noregular {
              padding: 0 12px 0 13px;
              color: #aaaaaa;
              // color: #ff0011;
            }
            .icon-a-lujing162 {
              color: #377cf1;
            }
            .icon-a-lujing157 {
              color: #ff8800;
            }
            .icon-a-ziyuan1 {
              color: #ff8800;
            }
          }
        }
        li:nth-child(2) {
          margin-left: 0;
        }
        li:nth-child(3) {
          margin-left: 0;
        }
        li:nth-child(4) {
          margin-left: 0;
        }
        li:nth-child(5) {
          margin-left: 0;
        }
      }
      .w105 {
        width: 100%;
        height: 300px;
        padding-top: 133px;
        // line-height: 350px;
        p {
          // margin-top: 200px;
          margin: auto;
          text-align: center;
          width: 100px;
          font-size: 14px;
          padding: 3px;
          color: #8b8c94;
          border: 1px solid #e2e2e2;
          border-radius: 3px;
        }
      }
    }
    // 店铺信息
    .main-Store {
      margin-top: 15px;
      margin-bottom: 26px;
      border: 1px solid #e2e2e2;
      .Store-span {
        padding: 9px 0 9px 11px;
        background-color: #f6f6f6;
        border-bottom: 1px solid #e2e2e2;
        line-height: 14px;
        .span {
          font-size: 14px;
          color: #555555;
          font-weight: bold;
        }
        .icon-shangcheng {
          font-size: 14px;
          color: #aaaaaa;
          margin-right: 3px;
        }
        // padding: 12px 0 3px 0;
        // margin-left: 17px;
        // margin-right: 18px;
        // text-align: left;
        // border-bottom: 1px solid #e2e2e2;
      }
      // 店铺信息
      .Store-list {
        background-color: #ffffff;
        display: flex;
        padding: 10px 16px 10px 11px;
        height: 120px;
        img {
          width: 100px;
          height: 100px;
        }
        .all-list {
          padding: 17px 0 0 15px;
          .Store-left {
            width: 1058px;
            // padding-bottom: 6px;
            border-bottom: 1px solid #e2e2e2;
            display: flex;
            .span-shopType {
              margin-top: 2px;
              height: 16px;
              font-size: 12px;
              line-height: 14px;
              color: #f62b4e;
              border: 1px solid #f62b4e;
              border-radius: 2px;
              margin-right: 3px;
            }
            .w2 {
              color: #ff5e00;
              border: 1px solid #ff5e00;
            }
            .w3 {
              color: #47c460;
              border: 1px solid #47c460;
            }
            .w4 {
              color: #377cf1;
              border: 1px solid #377cf1;
            }
            .li-1-span {
              font-size: 16px;
              color: #505050;
              font-weight: bold;
              line-height: 20px;
              height: 16px;
              margin: 0 6px 0 1px;
            }
            .li-2-span {
              display: inline-block;
              font-size: 12px;
              color: #505050;
              height: 16px;
              margin-left: 28px;

              // letter-spacing: 1px;
            }
            .icon-a-zu248 {
              display: inline-block;
              color: #ff8800;
              font-size: 14px;
              margin: 0 5px;
            }
            .icon-a-lujing162 {
              color: #0077ff;
              font-size: 14px;
              cursor: pointer;
            }
          }
          .Store-right {
            padding-top: 11px;
            display: flex;
            justify-content: space-between;
            .carType-left {
              p {
                span {
                  display: inline-block;
                  max-width: 400px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer;
                }
              }
            }
            .carType-right {
              width: 50%;
            }
            p {
              letter-spacing: 1px;
              font-size: 12px;
              line-height: 12px;
              color: #505050;
              span {
                font-size: 12px;
                color: #505050;
              }
            }
            .w10 {
              padding-top: 12px;
            }
          }
        }
      }
    }
    // 热销配件
    .main-HotParts {
      border: 1px solid #e2e2e2;
    }
    // 活动配件
    .main-EventParts {
    }
    // 厂商介绍
    .Firmennachweis {
      // height: 1100px;
      border: 1px solid #e2e2e2;
      margin-top: 28px;
      margin-bottom: 10px;
      .Firmennachweis-top {
        // margin: 18px 36px;
        .Firmennachweis-icon {
          background: #f6f6f6;
          padding: 12px 0 12px 11px;
          border-bottom: 1px solid #e6e6e6;
          // margin-bottom: 13px;
        }
        .iconfont {
          color: #aaaaaa;
          // font-weight: normal;
          font-size: 16px;
        }
        .span {
          color: #505050;
          font-weight: bold;
          font-size: 14px;
        }
        .div-p {
          width: 1167px;
          background: #ffffff;
          padding: 12px 13px 12px 18px;
          // overflow-y: auto;
          // height: 1000px;
          /deep/ .w111 {
            width: 100%;
            height: 100%;
            font-size: 12px;
            color: #505050;
            font-weight: 400;
            line-height: 26px;
            // p {
            //   display: inline-block;
            //   width: 100%;
            img {
              width: 100%;
            }
            // }
          }
        }
        .v-shows {
          height: 200px;
          background: #ffffff;
          padding-top: 100px;
          text-align: center;
          span {
            height: 30px;
            line-height: 30px;
            display: inline-block;
            width: 100px;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            border: 1px solid #e2e2e2;
            color: #8b8c94;
          }
        }
      }
    }
  }
}
</style>
